module.exports = __webpack_public_path__ + "img/qihang_erjian.ccc850d1.png";